export const apiReport = () => '/commercial/contractsUpdates/report'
export const apiReportPdf = () => '/commercial/contractsUpdates/reportPdf'
export const apiListInstitution = (): string => '/commercial/institutions/'
